import { Tag, Input, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useState, useRef, useEffect } from 'react';

const EditTag = styled(Tag)`
  user-select: none;
`;

const TagInput = styled(Input)`
  width: 90px;
  margin-top: 1px;
  height: 22px;
  font-size: 12px;
  margin-right: 8px;
  vertical-align: top;
`;

const TagContainer = styled.div`
  border: 1px solid #dadada;
  padding: 3px 5px;
`;


const EditableTagGroup = (props) => {

  const [ inputVisible, setInputVisible ] = useState();
  const [ inputValue, setInputValue ] = useState('');
  const [ editInputIndex, setEditInputIndex ] = useState(-1);
  const [ editInputValue, setEditInputValue ] = useState('');
  const { value = [], onChange = () => {} } = props;
  const inputEl = useRef();
  const editInputEl = useRef();
  const tags = value;

  const handleClose = removedTag => {
    const newTags = tags.filter(tag => tag !== removedTag);
    onChange(newTags);
  };

  useEffect(() => {
    if (inputVisible) {
      setTimeout(() => { inputEl.current.focus(); }, 100);
    }
    if (editInputIndex >= 0) {
      setTimeout(() => { editInputEl.current.focus(); }, 100);
    }
  }, [inputVisible, editInputIndex]);

  const showInput = () => {
    setInputVisible(true);
  };

  const handleInputChange = e => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    let newTags = tags;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      newTags = [...tags, inputValue];
    }
    onChange(newTags);
    setInputVisible(false);
    setInputValue('');
  };

  const handleEditInputChange = e => {
    setEditInputValue(e.target.value);
  };

  const handleEditInputConfirm = () => {
    const newTags = [...tags];
    newTags[editInputIndex] = editInputValue;
    onChange(newTags);
    setEditInputIndex(-1);
    setEditInputValue('');
  };

  return (
    <TagContainer>
      {tags && tags.map((tag, index) => {
        if (editInputIndex === index) {
          return (
            <TagInput ref={editInputEl} key={tag}
              size="small"
              value={editInputValue}
              onChange={handleEditInputChange}
              onBlur={handleEditInputConfirm}
              onPressEnter={handleEditInputConfirm}
            />
          );
        }

        const isLongTag = tag.length > 20;

        const tagElem = (
          <EditTag color='#1890ff' key={tag} closable={true} onClose={() => handleClose(tag)}>
            <span onDoubleClick={e => { setEditInputIndex(index); setEditInputValue(tag); e.preventDefault(); } }>
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </span>
          </EditTag>
        );
        return isLongTag ? (<Tooltip title={tag} key={tag}>{tagElem}</Tooltip>) : (tagElem);
      })}

      {!inputVisible && editInputIndex === -1 && (
        <Tag className="site-tag-plus" onClick={showInput}>
          <PlusOutlined /> New Tag
        </Tag>
      )}

      {inputVisible &&
        <TagInput
          ref={inputEl}  type="text" size="small"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      }
    </TagContainer>
  );
}

export default EditableTagGroup;